/**
 * 解绑流程共1个接口
 * - 支付密码解绑银行卡 /customer/unBindCardPwd
 *
 * - 解绑未设支付密码的银行卡 /customerV2/unbindBankCardsWithoutPayPwd
 * - 解绑银行卡 无密码版 更换设备时使用 /customer/unBindCard
 */

import fetch from '@/utils/fetch/index'

/**
 * 解绑银行卡
 * @param params
 * @returns
 */
export function unBindCard(params) {
  return fetch('/customer/unBindCardPwd', {
    params,
  })
}

/**
 * 解绑所有银行卡，适用于新用户绑卡后没有设置密码
 * @param params
 * @returns
 */
export function unBindCardNoPwd() {
  return fetch('/customerV2/unbindBankCardsWithoutPayPwd', {
    data: {},
    method: 'POST',
  })
}

/**
 * 解绑银行卡 无密码版 更换设备时使用
 * @param params
 * @returns
 */
export function unBindCardChangeDevice(params) {
  return fetch('/customer/unBindCard', {
    params,
  })
}
